export const EVENTS = {
  CREATE_REPORT_TEMPLATE: {
    name: 'report:create-new-template',
    action: 'GENERATE_REPORT_SUCCEEDED',
    fields: ['name'],
  },
  DOWNLOAD_REPORT: {
    name: 'report:download',
    action: 'DOWNLOAD_REPORT_SUCCEEDED',
    fields: ['name'],
  },
  DELETE_REPORT: {
    name: 'report:delete-template',
    action: 'DELETE_REPORT_SUCCEEDED',
    fields: ['name'],
  },
  DELETE_DOCUMENT: {
    name: 'document:delete',
    action: 'DELETE_LEDGER_RECORD_SUCCEEDED',
    fields: ['name'],
  },
  DOCUMENT_UPLOAD: {
    name: 'document:upload',
    action: 'UPLOAD_FILE_SUCCEEDED',
    fields: ['name', 'type', 'size', 'lastModified', 'lastModifiedDate'],
  },
  PRICING_VISIT: {
    name: 'pricing:visited',
    action: 'PRICING_VISITED',
    fields: [],
  },
  PRICING_SELECT: {
    name: 'pricing:plan-selection',
    action: 'PRICING_SELECTED',
    fields: ['plan'],
  },

  CREATE_VENDOR_ALIAS: {
    name: 'vendor:create-alias',
    action: 'CREATE_VENDOR_ALIAS',
    fields: ['id', 'name', 'alias'],
  },
  UPDATE_VENDOR_ALIAS: {
    name: 'vendor:update-alias',
    action: 'UPDATE_VENDOR_ALIAS',
    fields: ['id', 'name', 'alias'],
  },
  DELETE_VENDOR_ALIAS: {
    name: 'vendor:delete-alias',
    action: 'DELETE_VENDOR_ALIAS',
    fields: ['id', 'name'],
  },

  CREATE_VENDOR_GL_CODE: {
    name: 'vendor:create-gl-code',
    action: 'CREATE_VENDOR_GL_CODE',
    fields: ['id', 'name', 'alias', 'glCode'],
  },
  UPDATE_VENDOR_GL_CODE: {
    name: 'vendor:update-gl-code',
    action: 'UPDATE_VENDOR_GL_CODE',
    fields: ['id', 'name', 'alias', 'glCode'],
  },
  DELETE_VENDOR_GL_CODE: {
    name: 'vendor:delete-gl-code',
    action: 'DELETE_VENDOR_GL_CODE',
    fields: ['id', 'name', 'alias', 'glCode'],
  },

  CREATE_VENDOR_EXPENSE_CATEGORY: {
    name: 'vendor:create-expense-category',
    action: 'CREATE_VENDOR_EXPENSE_CATEGORY',
    fields: ['id', 'name', 'alias', 'expenseCategory'],
  },
  UPDATE_VENDOR_EXPENSE_CATEGORY: {
    name: 'vendor:update-expense-category',
    action: 'UPDATE_VENDOR_EXPENSE_CATEGORY',
    fields: ['id', 'name', 'alias', 'expenseCategory'],
  },
  DELETE_VENDOR_EXPENSE_CATEGORY: {
    name: 'vendor:delete-expense-category',
    action: 'DELETE_VENDOR_EXPENSE_CATEGORY',
    fields: ['id', 'name', 'alias', 'expenseCategory'],
  },
}
